<template>
    <!-- More information about GAPS here: https://w.amazon.com/bin/view/Pumas-team/OurOfferings/AccountSwitchers -->
    <div
        id="dropdown-account-switcher-container"
        :data-mode="dataMode"
        data-nature="vendorGroup"
        data-test-tag="dropdown-account-switcher-container"
    >
        <a class="account-switcher-fallback" :href="switcherHref" data-test-tag="account-switcher-fallback">
            {{ $t('header_accountSwitcher_switchAccounts') }}
        </a>
    </div>
</template>

<script>
import getWeblabTreatment from '../util/getWeblabTreatment';
import { Weblabs } from '../enums/Weblabs';

export default {
    name: 'AccountSwitcherLoader',
    methods: {
        appendScriptsToDom() {
            const idPrefix = 'dropdown-account-switcher-loader';
            const scriptEl = document.createElement('script');
            scriptEl.id = `${idPrefix}-script`;
            scriptEl.src = '/account-switcher/dropdown-assets-loader.js';
            scriptEl.setAttribute('data-test-tag', `${idPrefix}-script`);
            document.head.appendChild(scriptEl);
        },
    },
    mounted() {
        this.appendScriptsToDom();
    },
    computed: {
        isDefaultMode() {
            return getWeblabTreatment(Weblabs.gapsVendorCentralDefaultMode) === 'T1';
        },
        switcherHref() {
            return this.isDefaultMode
                ? '/account-switcher/default/vendorGroup'
                : '/account-switcher/regional/vendorGroup';
        },
        dataMode() {
            return this.isDefaultMode ? 'default' : 'regionalOnly';
        },
    },
};
</script>

<style lang="scss" scoped>
#dropdown-account-switcher-container {
    align-items: center;
    display: flex;
    height: 48px;
}

.account-switcher-fallback {
    font-size: 12px;
    line-height: 16px;
}
</style>
